import React from 'react';
import { Box, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { CustomButton, TextField } from '../../../v2/MUI_custom_component';
import { useSelector } from 'react-redux';
import { alphaNumericInputValidation } from '../../Common/Validation/alphaNumeric';

const MAX_PO_NUMBER_LENGTH = 50;

const PODetailsForm = ({
  poDetails,
  setPODetails,
  quantityError,
  setQuantityError,
  productDetails,
  selectedProductId,
  validateQuantity,
  onCreatePO,
  title
}) => {
  const handleQuantityChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9.]/g, '');
    const validValue = numericValue.replace(/(\..*?)\./g, '$1');
    
    setPODetails({...poDetails, quantity: validValue});
    const error = validateQuantity(validValue);
    setQuantityError(error);
  };

  const handleCreatePOClick = () => {
    const quantityValidationError = validateQuantity(poDetails.quantity);
    if (quantityValidationError) {
      setQuantityError(quantityValidationError);
      return;
    }
    if (productDetails?.products && productDetails.products.length > 1 && !selectedProductId) {
      toast.error('Please select a product');
      return;
    }
    onCreatePO();
  };

  const showHistory = useSelector(state => state.entityReducer.show_history);
  return (
    <Box sx={{
      p: 2,
      background: '#fff',
      borderRadius: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 1
    }}>
        {!title && (
            <Typography variant="h2">
               PO Details
            </Typography>
        )}
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 2, lg: 4},
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2
            }}>
            <TextField
                placeholder="Enter Quantity in tons"
                variant="standard"
                fullWidth
                label={`Quantity (in Tons)*`}
                value={poDetails.quantity}
                onChange={handleQuantityChange}
                error={!!quantityError}
                helperText={quantityError}
                type="number"
                inputProps={{ 
                    min: productDetails?.limits_info?.min_moq || 0, 
                    max: productDetails?.limits_info?.max_moq && productDetails.limits_info.max_moq > 0 ? productDetails.limits_info.max_moq : undefined,
                // step: "0.01" 
                }}
            />
            <TextField
                variant="standard"
                placeholder="Enter User PO No."
                fullWidth
                label="User PO No."
                value={poDetails.po_number}
                onChange={(e) => setPODetails({
                    ...poDetails,
                    po_number: alphaNumericInputValidation(e.target.value, MAX_PO_NUMBER_LENGTH).replace(/^\s+/, '')
                })}
            />
            </Box>
            <CustomButton
              variant="filled"
              color="primary"
              label="Create PO"
              onClick={handleCreatePOClick}
              disabled={!!quantityError || showHistory}
            />
        </Box>
    </Box>
  );
};

export default PODetailsForm;